module.exports = __webpack_public_path__ + "img/platinium.d5be9db6.png";